import { APPOINTMENT_UNSUPPORTED_MODAL } from 'constant'
import registerReduxModal from 'components/common/hoc/registerReduxModal'
import AppointmentUnsupportedModal from './AppointmentUnsupportedModal'

export default registerReduxModal({
  name: APPOINTMENT_UNSUPPORTED_MODAL
})(AppointmentUnsupportedModal)

